// Copyright (c) 2016 Deere & Company

import CscUserRoutingInfo, {getDefaultState as getCscUserRoutingInfoDefaultState} from './csc-user-routing-info';
import KeyValuePairCollection, {getDefaultState as getKeyValuePairCollectionDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import Preferences, {getDefaultState as getPreferencesDefaultState} from './preferences';
import Security, {getDefaultState as getSecurityDefaultState} from '@deere/cps-it.warranty-model-factory/lib/security';
import Territories, {getDefaultState as getTerritoriesDefaultState} from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy';
import User, {getDefaultState as getUserDefaultState} from '@deere/cps-it.warranty-model-factory/lib/user';
import t from 'tcomb';

const UserState = t.struct({
    cscUserRoutingInfo: CscUserRoutingInfo,
    details: User,
    entitlements: KeyValuePairCollection,
    preferences: Preferences,
    security: Security,
    territories: Territories
}, 'UserState');

export const getDefaultState = () =>
    new UserState({
        cscUserRoutingInfo: getCscUserRoutingInfoDefaultState(),
        details: getUserDefaultState(),
        entitlements: getKeyValuePairCollectionDefaultState(),
        preferences: getPreferencesDefaultState(),
        security: getSecurityDefaultState(),
        territories: getTerritoriesDefaultState()
    });

export default UserState;



// WEBPACK FOOTER //
// ./src/user/shared/state/index.js